<template>
  <ValidationObserver class="w-100" ref="observerPartner" v-slot="{ validate }">
    <div class="row">
      <div class="col-md-6">
        <ValidationProvider
          name="Tên khách hàng"
          rules="required|lBetween:1,255|CHECK_HTML"
          v-slot="{ errors, valid }">
          <label>Tên khách hàng <sup class="text-danger"> * </sup></label>
          <b-form-input
            id="formrow-firstname-input"
            type="text"
            placeholder="Nhập tên khách hàng"
            v-model="dataCustomer.name"
            :state="errors[0] ? false : valid ? true : null"
            @keydown.enter.prevent
          />
          <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
        </ValidationProvider>
      </div>
      <div class="col-md-6">
        <b-form-group label="" label-for="formrow-phone-input">
          <ValidationProvider
            name="Số điện thoại"
            rules="PHONE_NO_3|CHECK_HTML|lBetween:1,15|required"
            v-slot="{ errors, valid }">
            <label>Số điện thoại<sup class="text-danger">*</sup></label>
            <b-form-input
              id="formrow-phone-input"
              type="text"
              placeholder="Nhập số điện thoại"
              v-model.trim="dataCustomer.phoneNo"
              @keydown.enter.prevent
              @keydown="allowNumbersOnly"
              :state="errors[0] ? false : valid && dataCustomer.phoneNo != null ? true : null"/>
            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
          </ValidationProvider>
        </b-form-group>
      </div>
    </div>

    <b-form-group
      id="input-group-1"
      label=""
      label-for="formrow-inputField">
      <label>Tỉnh/Thành phố</label>
      <multiselect
        v-model="dataCustomer.city"
        track-by="id"
        label="text"
        deselectLabel=""
        selectLabel=""
        selectedLabel=""
        placeholder="Chọn Tỉnh/Thành phố"
        :options="listCity"
        :allow-empty="false"
        @select="getListDistrictHere($event)">
        <template slot="noOptions"> Chưa có dữ liệu </template>
        <template slot="noResult">Không tìm thấy dữ liệu</template>
      </multiselect>
    </b-form-group>

    <div class="row">
      <div class="col-md-6">
        <b-form-group
          id="input-group-1"
          label=""
          label-for="formrow-inputField">
          <label>Quận/Huyện</label>

          <multiselect
            v-model="dataCustomer.district"
            track-by="id"
            label="text"
            deselectLabel=""
            selectLabel=""
            selectedLabel=""
            placeholder="Chọn Quận/Huyện"
            :options="listDistrict"
            :allow-empty="false"
            @select="getListWardHere($event)">
            <template slot="noOptions"> Chưa có dữ liệu </template>
            <template slot="noResult">Không tìm thấy dữ liệu</template>
          </multiselect>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group
          id="input-group-1"
          label=""
          label-for="formrow-inputField">
          <label>Phường/Xã</label>
          <multiselect
            v-model="dataCustomer.ward"
            track-by="id"
            label="text"
            deselectLabel=""
            selectLabel=""
            selectedLabel=""
            placeholder="Chọn Phường/Xã"
            :options="listWard">
            <template slot="noOptions"> Chưa có dữ liệu </template>
            <template slot="noResult">Không tìm thấy dữ liệu</template>
          </multiselect>
        </b-form-group>
      </div>
    </div>

     <b-form-group label="" label-for="formrow-address-input">
      <ValidationProvider
        name="Địa chỉ cụ thể"
        rules="lBetween:3,255|CHECK_HTML"
        v-slot="{ errors, valid }">
        <label>Địa chỉ cụ thể</label>

        <b-form-textarea
          v-model.trim="dataCustomer.address"
          id="formrow-address-input"
          class="form-control"
          name="textarea"
          rows="3"
          placeholder="Nhập địa chỉ"
          :state="errors[0] ? false : valid && dataCustomer.address != null && dataCustomer.address != '' ? true : null"
        />

        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
      </ValidationProvider>
    </b-form-group>
    
    <!-- btn hỗ trợ click từ cpn cha -->
    <button class="d-none" ref="btnClick" @click="submitInCpn(validate)">click</button>

    <!-- loading -->
    <div class="box-loading" v-if="loading">
      <div class="loading">
        <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
      </div>
    </div>
  </ValidationObserver>  
</template>

<script>
import { OrdersService } from '../../../services/nextshop/orders.service';
import {getListCity, getListDistrict, getListWard} from "@/utils/address.js"


export default {
  props: ["id", "partyB"],
  data() {
    return {
      inforAccount: JSON.parse(localStorage.getItem("auth.currentUser")),
      loading: false,
      // list address
      listCity: [],
      listDistrict: [],
      listWard: [],

      dataCustomer: {
        name: this.partyB.displayName,
        phoneNo: this.partyB.phoneNo,
        city: null,
        district: null,
        ward: null,
        address:  this.partyB.address,
        cityCode:  "",
        districtCode:  "",
        wardCode:  "",
      },
    }
  },
  // async created() {
  //   this.createData()
  // },
  methods: {
    async createData() {
      try {
        this.loading = true
        // tét
        // this.partyB.otherInfo ={
        //   "city": "hni",
        //   "district": "bah",
        //   "village": "cngvi5"
        // }

        this.dataCustomer.cityCode = this.partyB.otherInfo.city ? this.partyB.otherInfo.city : null
        this.dataCustomer.districtCode = this.partyB.otherInfo.district ? this.partyB.otherInfo.district : null
        this.dataCustomer.wardCode = this.partyB.otherInfo.village ? this.partyB.otherInfo.village : null
        await this.getListCityHere();
        const cityId = this.dataCustomer.city ? this.dataCustomer.city.id : null
        if(cityId) {
          await this.getListDistrictHere({ id: cityId });
        }
        const districtId = this.dataCustomer.district ? this.dataCustomer.district.id : null
        if(districtId) {
          await this.getListWardHere({ id: districtId });
        }
        
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async fetchData() {
      // this.dataCustomer = {...this.dataCustomer, ... this.partyB}
      // this.loading = true;
      // try {
      //   const response = await CustomerServices.getCustomerById({
      //     merchantId: this.inforAccount.merchantId,
      //     query: this.partyB.resId,
      //   });
      //   if (response.success) {
      //     // this.dataCustomer = {...this.dataCustomer,...response.data};
      //     console.log( 111 , response);
      //   }
      // } catch (error) {
      //   console.log(error);
      //     this.showSwalError("Lấy dữ liệu", error)
      // } finally {
      //   this.loading = false;
      // }
    },
    submit() {
      this.$refs.btnClick.click()
    },
    submitInCpn(validate) {
      // console.log("submit 33", validate)
      validate().then(async (success) => {
      // this.messageError = new Object();
        if (!success) {
          const el = document.querySelector(".is-invalid");
          el.focus();
          return;
        } else {
          console.log("OK");
          console.log(this.dataCustomer);
          this.requestUpdateOrder()

        }
      })
    },

    async requestUpdateOrder() {
      const params = {
        "orderId": this.id,
          "partyB": {
            "title": this.partyB.displayName,
            "displayName": this.dataCustomer.name,
            "address": this.dataCustomer.address,
            "phoneNo": this.dataCustomer.phoneNo,
            "role": "BUYER",
            "otherInfo": {
              "city": this.dataCustomer.city ? this.dataCustomer.city.id : null ,
              "district":  this.dataCustomer.district ? this.dataCustomer.district.id : null,
              "village":  this.dataCustomer.ward ? this.dataCustomer.ward.id : null,
            }
          },
          "note": ""
      }
      // console.log(params)
      // return
      try {
        this.loading = true
        const response = await OrdersService.updateOrderCustomer(params)
        // console.log(123, response )
        if (response.success) {
          this.showSwalSuccess("Cập nhật")
          this.$emit('closeModal')

        } else {
          this.showSwalError("Cập nhật", response.message)
        }
      } catch (error) {
        this.showSwalError("Cập nhật", error)
      } finally {
        this.loading = false
      }
    },
    
    async getListCityHere() {
      this.listCity = await getListCity();
      const OBJ = await this.listCity.find((e) =>
        e.id == this.dataCustomer.cityCode
      );
      this.dataCustomer.city = OBJ;
    },
    async getListDistrictHere({ id }) {
      try {
        this.loading = true
        this.listDistrict = [];
        this.listWard = [];
        const cityCode = id
        this.listDistrict = await getListDistrict(cityCode);
        const OBJ = this.listDistrict.find((e) => e.id == this.dataCustomer.districtCode)
        this.dataCustomer.district = OBJ;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false
      }
    },
    async getListWardHere({ id }) {
      try {
        this.loading = true
        
        this.listWard = [];
        const cityCode = this.dataCustomer.city.id
        const districtCode = id
        this.listWard = await getListWard(cityCode, districtCode)
        const OBJ = this.listWard.find((e) =>e.id == this.dataCustomer.wardCode);
        this.dataCustomer.ward = OBJ;

      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  }
}
</script>

<style>

</style>